const ITEMS = [
  "Drum Circles",
  "Team Building",
  "Venue Production",
  "Artist Management",
  "Live Bands",
  "Venue Finding",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="marquee-ribbon"
      className="relative overflow-hidden border-y border-[rgba(212,175,55,0.25)] bg-[#0d0d10] py-6"
    >
      <div className="animate-marquee flex w-max whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center font-cinzel text-lg sm:text-2xl tracking-[0.3em] uppercase text-zinc-500"
              >
                <span className="px-8 hover:text-[#d4af37] transition-colors duration-500">
                  {item}
                </span>
                <span className="text-[#d4af37] text-sm">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
